import * as React from "react";
import {Option} from "ts-option";
import "./tableHeaderCell.scss"

interface IProps {
	name: string;
	isDraggable?: boolean
	isAsc: Option<boolean>
}

export default class TableHeaderCell extends React.PureComponent<IProps> {

	render() {
		return (
			<div className={`${this.props.isDraggable ? "draggable-header" : "" }`}>
				<span>{this.props.name}</span>
				{this.props.isAsc.map(isAsc =>
					<span key={`${isAsc}`} className={"c-header-cell_sort-indicator"}>
						<i className={`fa fa-fw fa-caret-up ${isAsc ? "blue" : "blue-medium"}`}/>
						<i className={`fa fa-fw fa-caret-down ${!isAsc ? "blue" : "blue-medium"}`}/>
					</span>
				).orNull}
			</div>
		)
	}
}